module.exports = __webpack_public_path__ + "img/timg.d3cd22bf.jpg";